<template>
  <ListFilterForm
    :is-filter-enabled="props.isFilterEnabled"
    :initial-filter="initialFilter"
    @toggle-filter="emits('toggleFilter')"
    @set-filter="setParentFilter"
  >
    <template #fields="slotProps">
      <div class="flex flex-col">
        <label class="small-label">ID дашборда в DataLens</label>
        <InputText
          placeholder="Введите значение"
          v-model="slotProps.filter.datalens_id"
          aria-describedby="username-help"
        />
      </div>

      <div class="flex flex-col m-t-8">
        <label class="small-label">Название</label>
        <InputText
          placeholder="Введите название"
          v-model="slotProps.filter.name"
          aria-describedby="username-help"
        />
      </div>

      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Организация</label>
        <CatalogDataBaseInput
          :useIdOnly="true"
          selectType="organization"
          :isSegmentSetted="false"
          :modelValue="slotProps.filter.organization"
          @update:modelValue="
            ($event) => (slotProps.filter.organization = $event)
          "
        ></CatalogDataBaseInput>
      </div>

      <div class="flex flex-col m-t-8">
        <label for="state" class="small-label">Автор</label>
        <CatalogDataBaseInput
          :useIdOnly="true"
          selectType="user"
          :isSegmentSetted="false"
          :modelValue="slotProps.filter.user"
          @update:modelValue="($event) => (slotProps.filter.user = $event)"
        ></CatalogDataBaseInput>
      </div>
      <div class="flex flex-col m-t-8">
        <div class="toggle-row">
          <label for="include_demo" class="small-label"
            >Включать в список воркбуки демо-аккаунтов</label
          >
          <InputSwitch
            v-model="slotProps.filter.include_demo"
            inputId="include_demo"
          />
        </div>
      </div>

      <div class="flex flex-col m-t-8">
        <label for="date" class="small-label">Дата создания</label>
        <Calendar
          id="date"
          panelClass="not-extended"
          placeholder="Выберите значение"
          v-model="slotProps.filter.cdate"
          aria-describedby="date-help"
          showIcon
          iconDisplay="input"
          inputId="icondisplay"
        />
      </div>
      <div class="flex flex-col m-t-8">
        <label for="date" class="small-label">Дата редактирования</label>
        <Calendar
          id="date"
          panelClass="not-extended"
          placeholder="Выберите значение"
          v-model="slotProps.filter.mdate"
          aria-describedby="date-help"
          showIcon
          iconDisplay="input"
          inputId="icondisplay"
        />
      </div>

      <div class="flex flex-col m-t-8">
        <label class="small-label"
          >Добавляются в демо-аккаунты при создании</label
        >
        <div class="fl m-b-8 m-t-4">
          <RadioButton
            v-model="slotProps.filter.include_to_demo_accounts"
            inputId="include_to_demo_accounts_yes"
            name="include_to_demo_accounts"
            value="1"
          />
          <label for="include_to_demo_accounts_yes" class="p-l-4">Да</label>
        </div>
        <div class="fl">
          <RadioButton
            v-model="slotProps.filter.include_to_demo_accounts"
            inputId="include_to_demo_accounts_no"
            name="include_to_demo_accounts"
            value="0"
          />
          <label for="include_to_demo_accounts_no" class="p-l-4">Нет</label>
        </div>
      </div>
    </template>
  </ListFilterForm>
</template>

<script setup lang="ts">
import InputText from "primevue/inputtext";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";
import Calendar from "primevue/calendar";
import RadioButton from "primevue/radiobutton";
import InputSwitch from "primevue/inputswitch";

const props = defineProps<{
  isFilterEnabled: boolean;
}>();
const emits = defineEmits(["toggleFilter", "setFilter"]);

const initialFilter = {
  name: "",
  datalens_id: "",
  cdate: null,
  mdate: null,
  user: [] as number[],
  organization: [] as number[],
  include_demo: false,
  include_to_demo_accounts: "",
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};
</script>

<style scoped lang="scss">
.toggle-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
</style>
